module.exports = __webpack_public_path__ + "img/vertical_7_5_7042.15c0858f.png";